import React, {Component} from 'react';
import {
    Input,
    Label,
    Col,
    FormGroup,
    Form,
    Collapse,
    Button,
    Popover,
    PopoverBody
} from 'reactstrap';
import {Redirect} from 'react-router-dom';
import _ from 'lodash';
import './PriorConsentDetails.css';
import PropTypes from 'prop-types';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {
    AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST,
    AVAILABLE_PRIOR_CONSENT_TYPES
} from "../../../constants/constants";
import {Utils} from "../../../utils/utils";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import PeriodSelect from "../periodSelect/PeriodSelect.container";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import DomainInput from "../../commonComponents/domainInput/DomainInput";

const MAX_PERIOD = moment.duration(3, AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.MONTH).add(1, 'day');
const MIN_PERIOD = moment.duration(1, AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.WEEK).subtract(1, 'day');
const DEFAULT_PERIOD_TYPE = AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.MONTH;
const DEFAULT_PERIOD_NUM = '1';

const requiredSelectFields = ['targetType'];

const TARGET_TYPE_OPTIONS = [
    {
        code: AVAILABLE_PRIOR_CONSENT_TYPES.PERSON,
        name: 'consents.person_label'
    },
    {
        code: AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION,
        name: sharedLabelsPath.org_label
    },
    {
        code: AVAILABLE_PRIOR_CONSENT_TYPES.ANYONE,
        name: 'prior_consents.anyone_label'
    }
];

export const ACTION_TYPES = {
    ADD: 'add',
    EDIT: 'edit'
};


class AddPriorConsent extends Component {
    constructor(props) {
        super(props);

        let now = moment();
        this.state = {
            targetType: '',
            personEmail: '',
            orgDomain: '',
            metadata: {
                firstName: '',
                lastName: ''
            },
            enabledTill: moment(),
            grantedPeriodDays: moment.duration(moment(now).add(+DEFAULT_PERIOD_NUM, DEFAULT_PERIOD_TYPE).diff(moment(now), 'days'), 'days').asDays(),
            responseComment: '',
            periodType: DEFAULT_PERIOD_TYPE,
            periodNum: DEFAULT_PERIOD_NUM,
            popoverOpen: false,
            requiredFieldError: null
        }
    }

    componentWillMount() {
        if (this.props.actionType === ACTION_TYPES.EDIT && !_.isNil(this.props.id)) {
            this.props.onMount(this.props.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.success && nextProps.success && nextProps.actionType === ACTION_TYPES.ADD) {
            this.resetData();
        }

        if (_.isNil(this.props.data) && !_.isNil(nextProps.data)) {
            let period = this.getPeriodByDaysNumber(nextProps.data.grantedPeriodDays, nextProps.data.createdAt);
            this.setState({
                targetType: nextProps.data.targetType,
                personEmail: nextProps.data.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.PERSON ? nextProps.data.targetId : '',
                orgDomain:  nextProps.data.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION ? nextProps.data.targetId : '',
                metadata: {
                    firstName: nextProps.data.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.PERSON ? nextProps.data.metadata.firstName : '',
                    lastName: nextProps.data.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.PERSON ? nextProps.data.metadata.lastName : ''
                },
                enabledTill: moment(nextProps.data.enabledTill),
                grantedPeriodDays: nextProps.data.grantedPeriodDays,
                responseComment: nextProps.data.responseComment || '',
                periodType: period.periodType,
                periodNum: period.periodNum.toString()
            })
        }
    }

    getPeriodByDaysNumber = (daysNumber, createdAt) => {
        let duration = moment(createdAt).add(daysNumber, 'd').diff(moment(createdAt));
        let periodNum = 1;
        let periodType = AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.MONTH;
        let currentDuration = moment(createdAt).add(periodNum, periodType);
        while (currentDuration.clone().subtract(MAX_PERIOD).isBefore(moment(createdAt))) {
            if (duration === currentDuration.diff(moment(createdAt))) {
                return {
                    periodType,
                    periodNum
                };
            }
            periodNum++;
            currentDuration = moment(createdAt).add(periodNum, periodType);
        }
        periodNum = 1;
        periodType = AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.WEEK;
        currentDuration = moment(createdAt).add(periodNum, periodType);
        while (currentDuration.clone().subtract(MAX_PERIOD).isBefore(moment(createdAt))) {
            if (duration === currentDuration.diff(moment(createdAt))) {
                return {
                    periodType,
                    periodNum
                };
            }
            periodNum++;
            currentDuration = moment(createdAt).add(periodNum, periodType);
        }

        return {
            periodType: DEFAULT_PERIOD_TYPE,
            periodNum: DEFAULT_PERIOD_NUM
        }
    };

    render() {
        if (this.props.success) {
            return <Redirect to='/prior-consents' push />
        }
        return (
            <div className='prior-consent-container'>
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'prior_consents.' + this.props.actionType + '_prior_consent_success_message')}>
                    <BackButtonComponent path='/prior-consents' label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <div className='prior-consent-form'>
                        <h4 className='text-center'>{_.get(this.props.translation, 'prior_consents.' + this.props.actionType + '_prior_consent_label')}</h4>
                        <div className="prior-consents-hint-container">
                            <div className="prior-consents-hint" key="prior_consent_hint_part_1">{_.get(this.props.translation, 'prior_consents.prior_consents_hint_part_1')}</div>
                            <div className="prior-consents-hint" key="prior_consent_hint_part_2">{_.get(this.props.translation, 'prior_consents.prior_consents_hint_part_2')}</div>
                            <div className="prior-consents-hint" key="prior_consent_hint_part_3">{_.get(this.props.translation, 'prior_consents.prior_consents_hint_part_3')}</div>
                        </div>
                        {this.renderContent()}
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }

        return (
            <Form className='add-prior-consent-from' onSubmit={this.handleSubmit}>
                {this.renderTargetTypeSelect()}
                <Collapse isOpen={this.state.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.PERSON}>
                    <h5 className="prior-consent-details-subtitle olive-green">{_.get(this.props.translation, 'consents.person_label')}</h5>
                    {this.renderPersonDataFormGroups()}
                </Collapse>
                <Collapse isOpen={this.state.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION}>
                    <h5 className="prior-consent-details-subtitle olive-green">{_.get(this.props.translation, sharedLabelsPath.org_label)}</h5>
                    {this.renderOrganizationDataFormGroups()}
                </Collapse>
                <h5 className="prior-consent-details-subtitle olive-green">{_.get(this.props.translation, 'prior_consents.period_label')}</h5>
                {this.renderEnabledTillFormGroup()}
                {this.renderGrantedPeriodDaysFormGroup()}
                {this.renderCommentFormGroup()}
                <div className='button-group'>
                    <Button type="submit" className="olive-green-btn" disabled={this.saveButtonDisabled()}>
                        {_.get(this.props.translation, this.props.actionType === ACTION_TYPES.ADD ? sharedLabelsPath.add_button : sharedLabelsPath.save_changes_button)}
                    </Button>
                </div>
            </Form>
        )
    };

    saveButtonDisabled = () => {
        if (this.props.actionType === ACTION_TYPES.ADD) {
            return false;
        }

        if (_.isNil(this.props.data)) {
            return true;
        }

        if (this.props.data.targetType !== this.state.targetType ||
            moment(this.props.data.enabledTill).format('L') !== this.state.enabledTill.format('L') ||
            this.props.data.grantedPeriodDays !== this.state.grantedPeriodDays ||
            (this.props.data.responseComment || '')  !== this.state.responseComment) {
            return false;
        }

        switch (this.props.data.targetType) {
            case AVAILABLE_PRIOR_CONSENT_TYPES.PERSON:
                return this.state.personEmail === this.props.data.targetId &&
                    this.state.metadata.firstName === this.props.data.metadata.firstName &&
                    this.state.metadata.lastName === this.props.data.metadata.lastName;
            case AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION:
                return this.state.orgDomain === this.props.data.targetId;
            default:
                return true;
        }
    };

    renderTargetTypeSelect = () => {
        let params = {
            value: "targetType",
            title: _.get(this.props.translation, 'prior_consents.target_type_label'),
            type: 'select',
            isRequired: true,
            content: Utils.getOptions(
                _.map(TARGET_TYPE_OPTIONS, option => ({...option, name: _.get(this.props.translation, option.name)}))
            ),
            placeholder:_.get(this.props.translation, 'prior_consents.target_type_input_placeholder'),
            onChange: this.handleChangeSelect("targetType")
        };

        return this.getFormGroup(params);
    };

    renderPersonDataFormGroups = () => {
        let paramsList = [
            {
                value: "personEmail",
                title: _.get(this.props.translation, sharedLabelsPath.email_label),
                type: "email",
                isRequired: this.state.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.PERSON,
                placeholder: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            {
                value: "metadata.firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                onChange: this.handleMetadataChange('firstName')
            },
            {
                value: "metadata.lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                onChange: this.handleMetadataChange('lastName')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderOrganizationDataFormGroups = () => {
        let params = {
            value: "orgDomain",
            title: _.get(this.props.translation, sharedLabelsPath.domain_label),
            isRequired: this.state.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION,
            placeholder: _.get(this.props.translation, sharedLabelsPath.domain_label)
        };

        return this.getOrganizationDomainFormGroup(params);
    };

    getOrganizationDomainFormGroup = (params) => {
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <DomainInput id={id}
                                 value={this.state[params.value]}
                                 onChange={this.handleChangeDomainInput}
                                 placeholder={params.placeholder || params.title}
                                 disabled={params.isDisabled}
                                 required={params.isRequired}/>
                </Col>
            </FormGroup>
        );
    };

    getFormGroup = (params) => {
        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={_.get(this.state, params.value)}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}>
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderPopover = (params) => {
        if (params.value !== 'orgDomain') {
            return null;
        }
        return (
            <div className="prior-consent-details-domain-hint-container">
                <span id='prior-consent-details-icon-container' className='prior-consent-details-icon-container' onClick={this.togglePopover}>
                    <IconContainer icon='question_mark' title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                </span>
                <Popover placement="bottom" isOpen={this.state.popoverOpen} target="prior-consent-details-icon-container"
                         toggle={this.togglePopover}>
                    <PopoverBody>
                        {_.get(this.props.translation, 'register_org.domain_hint')}
                    </PopoverBody>
                </Popover>
            </div>
        );
    };

    togglePopover = () => {
        this.setState({popoverOpen: !this.state.popoverOpen});
    };


    renderEnabledTillFormGroup = () => {
        return (
            <FormGroup row key='enabled-till'>
                <Label for='enabled-till'
                       sm={3}>{_.get(this.props.translation, 'prior_consents.auto_grant_till_label')}*</Label>
                <Col sm={9}>
                    <DatePicker
                        customInput={<Input id='enabled-till'/>}
                        selected={this.state.enabledTill}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        required
                        onChange={this.handleChangeEnabledTill}
                        minDate={moment()}/>
                </Col>
            </FormGroup>
        )
    };

    renderGrantedPeriodDaysFormGroup = () => {
        return (
            <FormGroup row key='duration'>
                <Label for='duration'
                       sm={3}>{_.get(this.props.translation, 'prior_consents.duration_label')}*</Label>
                <Col sm={9}>
                    <PeriodSelect
                        id='prior-consent-period-select'
                        showPopover
                        placement='top'
                        periodEndDateMessage={
                            _.get(this.props.translation, 'prior_consents.duration_alert') + ' ' + this.state.grantedPeriodDays + ' ' + _.get(this.props.translation, 'prior_consents.days_label')}
                        onPeriodNumChange={this.handlePeriodNumChange}
                        onPeriodTypeChange={this.handlePeriodTypeChange}
                        periodType={this.state.periodType}
                        periodNum={this.state.periodNum}/>
                </Col>
            </FormGroup>
        );
    };

    renderCommentFormGroup = () => {
        let params = {
            value: "responseComment",
            type: "textarea",
            title: _.get(this.props.translation, 'prior_consents.response_comment_label'),
            placeholder: _.get(this.props.translation,  'prior_consents.response_comment_placeholder')
        };

        return this.getFormGroup(params);
    };

    handlePeriodNumChange = (nextPeriodNum) => {
        if (moment().add(nextPeriodNum, this.state.periodType).subtract(MAX_PERIOD).isBefore(moment())
        && moment().add(nextPeriodNum, this.state.periodType).subtract(MIN_PERIOD).isAfter(moment())) {
            let now = moment();
            this.setState({
                periodNum: nextPeriodNum,
                grantedPeriodDays: moment.duration(moment(now).add(+nextPeriodNum, this.state.periodType).diff(moment(now), 'days'), 'days').asDays()
            });
        }
    };

    handlePeriodTypeChange = (nextPeriodType) => {
        let nextPeriodNum = this.state.periodNum;
        if (!(moment().add(this.state.periodNum, nextPeriodType).subtract(MAX_PERIOD).isBefore(moment())
                && moment().add(this.state.periodNum, nextPeriodType).subtract(MIN_PERIOD).isAfter(moment()))) {
            nextPeriodNum = DEFAULT_PERIOD_NUM;
        }
        let now = moment();
        this.setState({
            periodType: nextPeriodType,
            periodNum: nextPeriodNum,
            grantedPeriodDays: moment.duration(moment(now).add(+nextPeriodNum, nextPeriodType).diff(moment(now), 'days'), 'days').asDays()
        });
    };

    handleChangeSelect = (fieldName) => (selectedOption) => {
        this.setState({[fieldName]: selectedOption.value});
    };

    handleChange = (fieldName) => (e) => {
        this.setState({[fieldName]: e.target.value});
    };

    handleChangeDomainInput = (data) => {
        this.setState({orgDomain: data});
    };

    handleMetadataChange = (fieldName) => (e) => {
        this.setState({metadata: {...this.state.metadata, [fieldName]: e.target.value}});
    };

    handleChangeEnabledTill = (date) => {
        this.setState({enabledTill: date});
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        let data = {
            targetType: this.state.targetType,
            grantedPeriodDays: this.state.grantedPeriodDays,
            enabledTill: moment(this.state.enabledTill).endOf('day'),
            responseComment: this.state.responseComment !== "" ? this.state.responseComment : null
        };

        if (this.state.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.PERSON) {
            data.targetId = this.state.personEmail;
            data.metadata = {};
            data.metadata.firstName = this.state.metadata.firstName;
            data.metadata.lastName = this.state.metadata.lastName;
        }

        if (this.state.targetType === AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION) {
            data.targetId = this.state.orgDomain;
        }

        switch (this.props.actionType) {
            case ACTION_TYPES.ADD:
                this.props.onProcess(data);
                break;
            case ACTION_TYPES.EDIT:
                this.props.onProcess(this.props.id, data);
                break;
            default:
                break;
        }
    };

    resetData = () => {
        this.setState({
            targetType: '',
            personEmail: '',
            orgDomain: '',
            metadata: {
                firstName: '',
                lastName: ''
            },
            enabledTill: moment(),
            grantedPeriodDays: moment.duration(+DEFAULT_PERIOD_NUM, DEFAULT_PERIOD_TYPE, 'days').asDays(),
            responseComment: '',
            periodType: DEFAULT_PERIOD_TYPE,
            periodNum: DEFAULT_PERIOD_NUM,
            popoverOpen: false
        })
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

AddPriorConsent.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    actionType: PropTypes.string.isRequired,
    success: PropTypes.bool,
    onProcess: PropTypes.func.isRequired,
    onMount: PropTypes.func
};

export default AddPriorConsent;



// WEBPACK FOOTER //
// ./src/components/consentManagement/priorConsentDetails/PriorConsentDetails.js